// import APIs
import { createOrUpdateNominalHoursDutyLine } from 'RestAPIs/employees/hours-table';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import external libraries
import { useMutation, useQueryClient } from 'react-query';

// import types
import { CreateOrUpdateNominalHoursDutyLineMutateParams } from './useCreateOrUpdateNominalHoursDutyLine.types';

const useCreateOrUpdateNominalHoursDutyLine = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: CreateOrUpdateNominalHoursDutyLineMutateParams) =>
      createOrUpdateNominalHoursDutyLine(params),

    {
      onSuccess: (_data, { employeeId }) => {
        queryClient.invalidateQueries(['hoursTable', employeeId]);
        showSuccessSnackbar();
      },
      onError: showErrorSnackbar
    }
  );
};

export default useCreateOrUpdateNominalHoursDutyLine;
